module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_latte_Front_30.8eabe876.png";